import { Map, OrderedMap, fromJS } from 'immutable';

import WorkspaceTemplates from 'Shared/constants/WorkspaceTemplates.constants';

const initialState = Map({
  [WorkspaceTemplates.State.WORKSPACES_TEMPLATES_BY_SLUG]: OrderedMap(),
});

export const WorkspaceTemplatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case WorkspaceTemplates.Actions.DELETE_WORKSPACE_TEMPLATE_SUCCESS:
      return state.deleteIn([
        WorkspaceTemplates.State.WORKSPACES_TEMPLATES_BY_SLUG,
        Object.values(action.payload.workspaceTemplate)[0].attributes.slug,
      ]);
    case WorkspaceTemplates.Actions.UPDATE_WORKSPACE_TEMPLATE_SUCCESS:
    case WorkspaceTemplates.Actions.FETCH_WORKSPACES_TEMPLATES_SUCCESS:
      return state.updateIn([WorkspaceTemplates.State.WORKSPACES_TEMPLATES_BY_SLUG], (existing = OrderedMap()) =>
        existing.merge(
          OrderedMap(
            Object.values(action.payload.workspaceTemplate).map(item => [
              item.attributes.slug,
              Map(fromJS(item.attributes)),
            ])
          )
        )
      );
    default:
      return state;
  }
};
